import React from "react";
import styled from "@emotion/styled";
import {useMediaQuery} from "react-responsive";
import {Flex, Heading} from "@adobe/react-spectrum";
import {PHONE_MAX_WIDTH} from "../utils/constants";
import trythis1 from "../assets/images/trythis-1.png";
import trythis2 from "../assets/images/trythis-2.png";
import trythis3 from "../assets/images/trythis-3.png";

const ImageView = styled.img({
    width: "100%",
    maxWidth: "608px",
    maxHeight: "275px",
    border: "1px solid #CCC"
})

function SectionTryThis() {

    const isPhone = useMediaQuery({maxWidth: PHONE_MAX_WIDTH});

    return (
        <Flex direction="column" gap="size-150" alignItems={isPhone ? "stretch" : "start"}>
            <Heading level={2}>Play and learn</Heading>
            <ImageView src={trythis1}/>
            <p>Drag the joystick fast, slow, or tap in a direction</p>
            <br/>
            <ImageView src={trythis2}/>
            <p>Follow links to learn more about fonts</p>
            <br/>
            <ImageView src={trythis3}/>
            <p>Compare fonts by opening a few links</p>


        </Flex>
    );
}

export default SectionTryThis;